import { useState, useRef, useEffect, Fragment } from "react";
import { PlusCircleIcon } from "components/Icons";
import { cn } from "tools/ui";

const colorMap = {
  total: "bg-purple-100 text-purple-700",
  available: "bg-green-100 text-green-700",
  active: "bg-yellow-100 text-yellow-700",
  reservation: "bg-blue-100 text-blue-700",
};

const colorMapHover = {
  total: "bg-purple-200 text-purple-800",
  available: "bg-green-200 text-green-800",
  active: "bg-yellow-200 text-yellow-800",
  reservation: "bg-blue-200 text-blue-800",
};

export default function TableCard({
  table,
  sales,
  onNewSale,
  onEditSale,
  selectTable = false,
  isSelected = false,
  onSelect,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const status = sales.some((s) => s.is_reservation)
    ? "reservation"
    : sales.length > 0
      ? "active"
      : "available";

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleButtonPlus = () =>
    status === "available" ? onNewSale?.(table) : setMenuOpen((o) => !o);

  function handleMenu(sale) {
    sale ? onEditSale?.(sale) : onNewSale?.(table);
    setMenuOpen(false);
  }

  function handleSelect() {
    if (selectTable && onSelect) {
      onSelect(table);
    }
  }

  return (
    <div
      key={table.id}
      onClick={handleSelect}
      className={cn(
        "relative flex flex-col p-4 rounded-xl shadow-md h-20 cursor-pointer",
        colorMap[status],
        !selectTable && "hover:shadow-md",
        selectTable && `hover:${colorMapHover[status]}`,
        selectTable && isSelected && "ring-2 ring-offset-2 ring-gray-400",
      )}
    >
      <div className="flex flex-row items-center justify-between">
        <span className="font-semibold text-center text-xs md:text-base">
          {table.name}
        </span>

        {!selectTable && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleButtonPlus();
            }}
            className="rounded-full text-white shadow-md hover:shadow-lg hover:scale-110 active:scale-95"
          >
            <PlusCircleIcon className="w-6 h-6 fill-zinc-600" />
          </button>
        )}
      </div>

      {!selectTable && (
        <div className="absolute top-2 right-2" ref={menuRef}>
          <div
            className={cn(
              "absolute right-0 mt-8 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-20",
              "transform origin-top transition-all scale-0",
              menuOpen && "opacity-100 scale-100",
            )}
          >
            <button
              type="button"
              onClick={() => handleMenu()}
              className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition"
            >
              Nuevo pedido
            </button>
            {sales.map((sale, idx) => (
              <button
                type="button"
                key={idx}
                onClick={() => handleMenu(sale)}
                className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition"
              >
                Editar #{sale.number}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* info de pedidos */}
      <div className="mt-2 text-sm font-medium text-gray-700">
        {sales.length > 0 ? `${sales.length} pedido(s)` : ""}
      </div>
    </div>
  );
}
